import CapsuleService from '@/services/api/CapsuleService';

export const discoverState = {
  discoverCapsules: {
    all: [],
    latest: [],
    metaData: {},
  }
};

export const discoverGetters = {
  discoverCapsules: state => state.discoverCapsules,
};

export const discoverActions = {
  resetDiscoverCapsules({ commit, dispatch }) {
    commit('SET_DISCOVER_CAPSULES', { type: 'all', data: [] });
    commit('SET_DISCOVER_CAPSULES', { type: 'latest', data: [] });
    commit('SET_DISCOVER_CAPSULES', { type: 'metaData', data: {} });
    dispatch('resetAllVotes')
  },

  fetchDiscoverCapsules({ commit }, payload) {
    const params = {
      filter: payload.filter,
      status: payload.status,
      page: payload.page,
      per_page: payload.per_page
    }

    return CapsuleService.getAll(params)
      .then((response) => {
        const { capsules, meta } = response.data
        const actionName = meta.current_page === 1
          ? 'SET_DISCOVER_CAPSULES'
          : 'APPEND_DISCOVER_CAPSULES'

        commit(actionName, { type: 'all', data: capsules });
        commit('SET_DISCOVER_CAPSULES', { type: 'latest', data: capsules });
        commit('SET_DISCOVER_CAPSULES', { type: 'metaData', data: meta });
      })
      .catch(error => {
        commit('SAVE_ERROR_RESPONSE', error.message);
      })
  },
}

export const discoverMutations = {
  SET_DISCOVER_CAPSULES(state, {type, data}) {
    state.discoverCapsules[type] = data
  },

  APPEND_DISCOVER_CAPSULES(state, { type, data }) {
    state.discoverCapsules[type] = state.discoverCapsules[type].concat(data)
  },
};


// WEBPACK FOOTER //
// ./src/store/modules/capsule/discover.js